import React, { useRef } from "react";
import styles from "./FolderCard.module.scss";
import { Checkbox } from "antd";

interface FolderCardProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  folderType?: 'folder' | 'file';
  variant?: 'internal' | 'external';
  selectable?: boolean;
  selected?: boolean;
  onSelectChange?: (checked: boolean) => void;
  sharedUsers?: Array<{
    id: number;
    firstName: string;
    lastName: string;
    thumbnailUrl?: string;
    organizationName?: string;
    isDeleted?: boolean;
  }>;
}

const FolderCard: React.FC<FolderCardProps> = ({
  children,
  className,
  style,
  onClick,
  folderType = 'folder',
  variant = 'internal',
  selectable = false,
  selected = false,
  onSelectChange,
  sharedUsers = [],
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={wrapperRef}
      className={`${styles.wrapper} ${folderType === 'file' ? styles.fileWrapper : ''} ${variant === 'external' ? styles.wrapperExternal : ''} ${className || ""}`}
      style={{ ...style, cursor: onClick ? 'pointer' : undefined }}
      onClick={onClick}
    >
      {selectable && (
        <Checkbox
          checked={selected}
          onChange={e => {
            onSelectChange?.(e.target.checked);
          }}
          className={styles.selectCheckbox}
          onClick={e => e.stopPropagation()}
        />
      )}
      {folderType === 'folder' ? (
        <div className={styles.folderCardContainer}>
          {/* Background div behind the masked folder */}
          <div className={styles.folderBackdrop} />
          
          {/* Background with folder shape using CSS mask */}
          <div className={`${styles.folderCard} ${variant === 'external' ? styles.folderCardExternal : ''}`} />
          
          {/* Content overlay */}
          <div className={styles.folderContent}>
            <div ref={contentRef} className={styles.folderContentInner}>
              {children}
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className={styles.fileIcon}>
            <div className={styles.fileBorder} />
          </div>
          <div className={styles.contentWrapper}>
            <div ref={contentRef} className={styles.fileContent}>
              {children}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FolderCard; 